import * as React from 'react';
export const bluecodeSvg = React.forwardRef(function bluecodeSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm10.588 11.432 7.915 4.566 4.72-2.726c.505-.296.677-.942.388-1.447a1.065 1.065 0 0 0-.388-.387L10.588 4.145A1.057 1.057 0 0 0 9 5.062v7.287a1.059 1.059 0 0 1 1.588-.917Zm12.635 7.293-4.72-2.72-7.915 4.566A1.059 1.059 0 0 1 9 19.654v7.287a1.059 1.059 0 0 0 1.588.917l12.635-7.293a1.064 1.064 0 0 0 0-1.84Z',
      fill: '#1961AC',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm10.588 20.571 7.915-4.566-7.915-4.567A1.057 1.057 0 0 0 9 12.355v7.305c0 .585.474 1.06 1.059 1.06a1.14 1.14 0 0 0 .529-.149Z',
      fill: '#004899',
    }),
  );
});
bluecodeSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var bluecode = {
  category: 'brand',
  colorable: false,
  name: 'bluecode',
  svg: bluecodeSvg,
};
